const state = {
    itens: [],
    item: {
        status: '',
        finish_contract: false
    }
};

export default state;